import { d as g } from "./index.es24.js";
import { __require as D } from "./index.es31.js";
import { i as b } from "./index.es38.js";
var c, h;
function _() {
  if (h) return c;
  h = 1;
  var p = g, u = D();
  function s(e, r) {
    this.init(e, r);
  }
  b(s, p), s.prototype.init = p;
  function m(e, r) {
    return u.getElementsByTagName(e, r, !0);
  }
  function f(e, r) {
    return u.getElementsByTagName(e, r, !0, 1)[0];
  }
  function l(e, r, a) {
    return u.getText(
      u.getElementsByTagName(e, r, a, 1)
    ).trim();
  }
  function d(e, r, a, i, t) {
    var n = l(a, i, t);
    n && (e[r] = n);
  }
  var y = function(e) {
    return e === "rss" || e === "feed" || e === "rdf:RDF";
  };
  return s.prototype.onend = function() {
    var e = {}, r = f(y, this.dom), a, i;
    r && (r.name === "feed" ? (i = r.children, e.type = "atom", d(e, "id", "id", i), d(e, "title", "title", i), (a = f("link", i)) && (a = a.attribs) && (a = a.href) && (e.link = a), d(e, "description", "subtitle", i), (a = l("updated", i)) && (e.updated = new Date(a)), d(e, "author", "email", i, !0), e.items = m("entry", i).map(function(t) {
      var n = {}, o;
      return t = t.children, d(n, "id", "id", t), d(n, "title", "title", t), (o = f("link", t)) && (o = o.attribs) && (o = o.href) && (n.link = o), (o = l("summary", t) || l("content", t)) && (n.description = o), (o = l("updated", t)) && (n.pubDate = new Date(o)), n;
    })) : (i = f("channel", r.children).children, e.type = r.name.substr(0, 3), e.id = "", d(e, "title", "title", i), d(e, "link", "link", i), d(e, "description", "description", i), (a = l("lastBuildDate", i)) && (e.updated = new Date(a)), d(e, "author", "managingEditor", i, !0), e.items = m("item", r.children).map(function(t) {
      var n = {}, o;
      return t = t.children, d(n, "id", "guid", t), d(n, "title", "title", t), d(n, "link", "link", t), d(n, "description", "description", t), (o = l("pubDate", t)) && (n.pubDate = new Date(o)), n;
    }))), this.dom = e, p.prototype._handleCallback.call(
      this,
      r ? null : Error("couldn't find root of feed")
    );
  }, c = s, c;
}
export {
  _ as __require
};
//# sourceMappingURL=index.es27.js.map
